import React from "react";
import TableFilters from "../../../Components/Common/TableFilters";

export default function TransactionHistoryFilters({
  dateRange,
  onDateChange,
  onSearchChange,
  searchQuery,
}) {
  return (
    <TableFilters
      className="bills-page__history-toolbar"
      dateRange={dateRange}
      onDateRangeChange={onDateChange}
      onSearchChange={onSearchChange}
      searchPlaceholder="Search transactions"
      searchValue={searchQuery}
      showDateRange
    />
  );
}
